export const BrowserSpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
export const BrowserSpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList
